import React, { FC } from 'react';
import { ButtonProps } from '~/core/dto/components/buttonDTO';

import './Button.styles.css';

const Button: FC<ButtonProps> = ( {
  children, className, isSubmit, disabled, onPress,
} ) => (
  <button
    className={`buttonComponent${disabled ? ' disabled' : ''} ${className ?? ''}`}
    onClick={onPress}
    type={isSubmit ? 'submit' : 'button'}
    disabled={disabled}
  >
    {children}
  </button>
);

export default Button;
